












































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import { DropDownController } from '@/services/request.service';
import { DropDownResponse } from '@/services/__model';
import moment from 'moment';
@Component
export default class LocationCascader extends Vue {
  @Model('change', { type: Array }) public location!: any;
  @Prop({
    default: () => {
      return { 'margin-bottom': '8px' };
    },
  })
  public marginBottom!: any;
  public cityList: Array<DropDownResponse> = [];
  public districtList: Array<DropDownResponse> = [];
  public province: string | undefined = '';
  public city: string | undefined = '';
  public district: string | undefined = '';

  public created(): void {
    this.resetFun();
    this.$store.dispatch('getProvinceList');
    if (this.location.length > 0 && this.location[0] && this.location[0] !== this.province) {
      this.province = this.location[0] || '';
      this.getCityList(this.location[0]);
    }
    if (this.location.length > 1 && this.location[1] && this.location[1] !== this.city) {
      this.city = this.location[1] || '';
      this.getDistrictList(this.location[1]);
    }
    if (this.location.length > 2 && this.location[2] && this.location[2] !== this.district) {
      this.district = this.location[2] || '';
    }
  }

  public resetFun(): void {
    this.province = undefined;
    this.city = undefined;
    this.district = undefined;
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  @Watch('location', { immediate: true })
  public getValue(newVal): void {
    if (newVal.length > 0 && newVal[0] && newVal[0] !== this.province) {
      this.province = newVal[0] || '';
      this.getCityList(newVal[0]);
    }
    if (newVal.length > 1 && newVal[1] && newVal[1] !== this.city) {
      this.city = newVal[1] || '';
      this.getDistrictList(newVal[1]);
    }
    if (newVal.length > 2 && newVal[2] && newVal[2] !== this.district) {
      this.district = newVal[2] || '';
    }
  }

  public handleProvinceChange(value: any, option: any): void {
    this.getCityList(value, () => {
      this.province = value;
      this.city = undefined;
      this.district = undefined;
      this.districtList = [];
      this.changeLocation();
    });
  }

  public handleCityChange(value: any, option: any): void {
    this.getDistrictList(value, () => {
      this.city = value;
      this.district = undefined;
      this.changeLocation();
    });
  }

  public handleDistrictChange(value: any, option: any): void {
    this.district = value;
    this.changeLocation();
  }

  public getCityList(value: string, fun?: any): void {
    DropDownController.getCityByProvince(value).then(res => {
      this.cityList = res && res.data ? res.data : [];
      fun && fun();
    });
  }

  public getDistrictList(value: string, fun?: any): void {
    DropDownController.getDistrictByCity(value).then(res => {
      this.districtList = res && res.data;
      fun && fun();
    });
  }

  public changeLocation(): void {
    this.$emit('change', [this.province || undefined, this.city || undefined, this.district || undefined]);
  }

  public checkAddress(): boolean {
    let flag = true;
    if (this.districtList.length > 0 && this.district === undefined) {
      flag = false;
    }
    if (this.cityList.length > 0 && this.city === undefined) {
      flag = false;
    }
    if (this.province === undefined) {
      flag = false;
    }
    return flag;
  }
}
